export default "__VITE_ASSET__Bw4VdJ6B__"